namespace GeniuzPOS.QRreport {
    export class QHourTimeColumns {
        static columnsKey = 'QRreport.QHourTime';
    }
}
